import styled from "styled-components";
import { tokens } from "../../../public/tokens";

export const StyledBooleanStatus = styled.div(({ $active }) => ({
  display: "flex",
  justifyContent: "center",
  color: $active ? tokens.colors.states.success.default : tokens.colors.states.alert.default,
}));

export const StyledArticulationCount = styled.div(({ $empty }) => ({
  color: $empty ? tokens.colors.states.alert.default : tokens.colors.text.primary,
  fontWeight: $empty ? tokens.typography.fontWeights.bold : tokens.typography.fontWeights.regular,
}));
